export default __webpack_public_path__ + "static/media/IELTS.a776b08c.png";